import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import React, { useState, useEffect, useRef } from 'react';
import apis from '../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import TimePicker from '../TimePicker/TimePicker';
import { excelExport } from '../../services/excelExport.service';

const ShiftConfiguration = () => {
    const [shifts, setShifts] = useState([])
    const [additionalList, setAdditionalList] = useState([])
    const [completeList, setCompleteList] = useState([])
    const [daysList, setDaysLists] = useState([])
    const [statusList, setStatusLists] = useState([])
    const [extraList, setExtraLists] = useState([])
    const [restList, setRestLists] = useState([])

    const [loadPage, setLoadPage] = useState(false);
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [isOpenShift, setIsOpenShift] = useState(false)
    const [isOpenShiftUpdate, setIsOpenShiftUpdate] = useState(false)
    const [isOpenShiftDelete, setIsOpenShiftDelete] = useState(false)

    const headers = { Authorization: localStorage.getItem("token") }
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')

    const [shiftId, setShiftId] = useState("")
    const [shiftName, setShiftName] = useState("")
    const [toleranceTime, setToleranceTime] = useState("")
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [additional, setAdditional] = useState("")
    const [completeShift, setCompleteShift] = useState("")
    const [shiftDay, setShiftDay] = useState("")
    const [shiftStatus, setShiftStatus] = useState("")
    const [overtime, setOvertime] = useState("")
    const [rest, setRest] = useState("")

    const toast = useRef(null);

    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [shiftSelected, setShiftSelected] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [exportContent, setExportContent] = useState([])
    const [loadingExport, setLoadingExport] = useState(false);

    useEffect(() => {
        getShiftList()
        getShift()
    }, [])

    const hideModalShift = () => {
        setShiftName("")
        setToleranceTime("")
        setStartTime("")
        setEndTime("")
        setAdditional("")
        setCompleteShift("")
        setShiftDay("")
        setShiftStatus("")
        setOvertime("")
        setRest("")
        setIsOpenShift(false)
    }

    const hideModalShiftUpdate = () => {
        setShiftName("")
        setToleranceTime("")
        setStartTime("")
        setEndTime("")
        setAdditional("")
        setCompleteShift("")
        setShiftDay("")
        setShiftStatus("")
        setOvertime("")
        setRest("")
        setShiftId("")
        setIsOpenShiftUpdate(false)
    }

    const hideModalShiftDelete = () => {
        setShiftName("")
        setToleranceTime("")
        setStartTime("")
        setEndTime("")
        setAdditional("")
        setCompleteShift("")
        setShiftDay("")
        setShiftStatus("")
        setOvertime("")
        setRest("")
        setShiftId("")
        setIsOpenShiftDelete(false)
    }


    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    const exportExcel = () => {
        try{
            excelExport(exportContent, 'ConfiguracionTurnos')
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
        }
        catch (err) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error al exportar", sticky: true });
        }
        finally{
            setLoadingExport(false);
        }
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-plus" label="Agregar" className="p-button-success p-button-sm " onClick={() => setIsOpenShift(true)}/>
                <div className='flex flex-row gap-1'>
                    <Button label="Exportar" icon="pi pi-file-excel" tooltip='Exportar información de la tabla' loading={loadingExport}
                              tooltipOptions={{ position: 'top' }} className="p-button-success mr-2 p-button-sm" onClick={() => { setLoadingExport(true); exportExcel() }} />
                    <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
                    </IconField>
                </div>
            </div>
        )
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'JOB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];
    
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
            { label: 5, value: 5 },
            { label: 10, value: 10 },
            { label: 20, value: 20 }
            ];

            return (
            <React.Fragment>
                <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
            </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
            <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                {options.first} - {options.last} of {options.totalRecords}
            </span>
            )
        }
    };

    const getShiftList = async () => {
        try{
            await apis.shiftConfList(entity, client, headers).then(res => { 
                setAdditionalList(res.data.ADDITIONAL)
                setCompleteList(res.data.COMPLETE_SHIFT)
                setDaysLists(res.data.TRK_LOV_SHIFT_DAY)
                setStatusLists(res.data.ESTADO_GENERAL)
                setExtraLists(res.data.PAY_HE)
                setRestLists(res.data.REST_DAY)
            })
        }
        catch(error){
            console.log(error)
        }
    }

    const getShift = async () => {
        setLoadPage(false)
        try{
            await apis.getShiftConf(entity, client, headers).then(res => {
                let contenidoExport = []
                const data = res.data.SHIFTS.map(shift => {
                    const additional_ = shift.ADDITIONAL.split('|')
                    const completeShift_ = shift.COMPLETE_SHIFT.split('|')
                    const shiftDay_ = shift.LOV_SHIFT_DAY.split('|')
                    const shiftStatus_ = shift.LOV_STATUS.split('|')
                    const overtime_ = shift.PAY_HE.split('|')
                    const rest_ = shift.REST_DAY.split('|')
                    let newShift = {
                        ...shift,
                        ADDITIONAL: additional_[0],
                        ADDITIONAL_DESC: additional_[1],
                        COMPLETE_SHIFT: completeShift_[0],
                        COMPLETE_SHIFT_DESC: completeShift_[1],
                        LOV_SHIFT_DAY: shiftDay_[0],
                        LOV_SHIFT_DAY_DESC: shiftDay_[1],
                        LOV_STATUS: shiftStatus_[0],
                        LOV_STATUS_DESC: shiftStatus_[1],
                        PAY_HE: overtime_[0],
                        PAY_HE_DESC: overtime_[1],
                        REST_DAY: rest_[0],
                        REST_DAY_DESC: rest_[1]
                    }
                    let newShiftExport = {
                        ID: shift.CONFIG_SHIFTS_ID,
                        Nombre: shift.NAME,
                        "Inicio turno": shift.START_TIME,
                        "Fin turno": shift.END_TIME,
                        "Inicio turno tolerancia": shift.START_TIME_TOLERANCE,
                        Adicional: additional_[1],
                        "Turno completo": completeShift_[1],
                        "Día turno": shiftDay_[1],
                        Estado: shiftStatus_[1],
                        "¿Paga horas extras?": overtime_[1],
                        "¿Es descanso?": rest_[1]
                    }
                    contenidoExport.push(newShiftExport)
                    return newShift
                    
                })
                console.log(data)
                setShifts(data)
                setExportContent(contenidoExport)
            })
        }
        catch(error){
            console.log(error)
        }
        finally{
            setLoadPage(true)
        }
    }

    const postShift = async () => {
        setLoading1(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                NAME: shiftName,
                START_TIME: startTime,
                END_TIME: endTime,
                START_TIME_TOLERANCE: toleranceTime,
                ADDITIONAL: additional.detail_id,
                COMPLETE_SHIFT: completeShift.detail_id,
                LOV_SHIFT_DAY: shiftDay.detail_id,
                LOV_STATUS: shiftStatus.detail_id,
                PAY_HE: overtime.detail_id,
                REST_DAY: rest.detail_id
            }
            await apis.postShiftConf(payload, headers).then(res => {
                getShift()
                hideModalShift()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Turno creado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading1(false)
        }
    }

    const putShift = async () => {
        setLoading2(true)
        try{
            const payload = {
                ENTITY: entity,
                CLIENT: client,
                CONFIG_SHIFTS_ID: shiftId,
                NAME: shiftName,
                START_TIME: startTime,
                END_TIME: endTime,
                START_TIME_TOLERANCE: toleranceTime,
                ADDITIONAL: additional.detail_id,
                COMPLETE_SHIFT: completeShift.detail_id,
                LOV_SHIFT_DAY: shiftDay.detail_id,
                LOV_STATUS: shiftStatus.detail_id,
                PAY_HE: overtime.detail_id,
                REST_DAY: rest.detail_id
            }
            await apis.putShiftConf(payload, headers).then(res => {
                getShift()
                hideModalShiftUpdate()
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Turno actualizado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading2(false)
        }
    }

    const deleteShift = async () => {
        setLoading3(true)
        try{
            await apis.delShiftConf(entity, client, shiftId, headers).then(res => {
                getShift()
                hideModalShiftDelete()
                toast.current.show({ severity: 'info', summary: 'Éxito', detail: "Turno eliminado exitosamente"});
            })
        }
        catch(err){
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
        finally{
            setLoading3(false)
        }
    }

    const setShiftData = (rowData) => {
        const additional_ = additionalList.filter(add => add.detail_id === rowData.ADDITIONAL)[0]
        const completeShift_ = completeList.filter(com => com.detail_id === rowData.COMPLETE_SHIFT)[0]
        const shiftDay_ = daysList.filter(day => day.detail_id === rowData.LOV_SHIFT_DAY)[0]
        const shiftStatus_ = statusList.filter(sta => sta.detail_id === rowData.LOV_STATUS)[0]
        const overtime_ = extraList.filter(ext => ext.detail_id === rowData.PAY_HE)[0]
        const rest_ = restList.filter(res => res.detail_id === rowData.REST_DAY)[0]
        console.log(rowData)
        console.log(additional_)
        setShiftId(rowData.CONFIG_SHIFTS_ID)
        setStartTime(rowData.START_TIME)
        setEndTime(rowData.END_TIME)
        setToleranceTime(rowData.START_TIME_TOLERANCE)
        setShiftName(rowData.NAME)
        setAdditional(additional_)
        setCompleteShift(completeShift_)
        setShiftDay(shiftDay_)
        setShiftStatus(shiftStatus_)
        setOvertime(overtime_)
        setRest(rest_)
        setIsOpenShiftUpdate(true)
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row gap-1'>
                <Button icon="pi pi-pencil" className="p-button-warning p-button-sm text-xs" onClick={() => setShiftData(rowData)}/>
                <Button icon="pi pi-trash" className="p-button-danger p-button-sm text-xs" onClick={() => {setShiftId(rowData.CONFIG_SHIFTS_ID); setIsOpenShiftDelete(true)}}/>
            </div>
        )
    }

    const addShiftFooter = (
        <div>
            <Button onClick={() => { setLoading1(false); hideModalShift() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading1} onClick={() => postShift()} disabled={!shiftName || !startTime || !endTime || !additional || !completeShift || !shiftDay || !shiftStatus || !overtime || !rest}/>
        </div>
    );

    const addShiftHeader = (
        <div>
            <h3>Agregar turno</h3>
        </div>
    )

    const updateShiftFooter = (
        <div>
            <Button onClick={() => { setLoading2(false); hideModalShiftUpdate() }}>Cancelar</Button>
            <Button label="Guardar" loading={loading2} onClick={() => putShift()} disabled={!shiftName || !startTime || !endTime || !additional || !completeShift || !shiftDay || !shiftStatus || !overtime || !rest}/>
        </div>
    );

    const updateShiftHeader = (
        <div>
            <h3>Editar turno</h3>
        </div>
    )

    const deleteShiftFooter = (
        <div>
            <Button onClick={() => { setLoading3(false); hideModalShiftDelete() }}>Cancelar</Button>
            <Button className="p-button-danger" label="Eliminar" loading={loading3} onClick={() => deleteShift()} />
        </div>
    );

    const deleteShiftHeader = (
        <div>
            <h3>¿Desea eliminar el turno?</h3>
        </div>
    )

    const msgContent = (
        <div>
            <a style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#3b82f6' }}>
            {process.env.REACT_APP_DISABLE_MSG}
            </a>
        </div>
    )

    return(
        <div className="flex flex-wrap align-items-center justify-content-center flex-column align-self-center">
            <Tooltip target=".info" className='indigo-tooltip ml-1' />
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />
            <Dialog header={addShiftHeader} footer={addShiftFooter} visible={isOpenShift}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalShift}>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Nombre</label>
                    <InputText value={shiftName} onChange={(e) => setShiftName(e.target.value)} placeholder="Nombre" className="p-inputtext-sm"/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Inicio turno</label>
                    <TimePicker value={startTime} onChange={setStartTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Fin turno</label>
                    <TimePicker value={endTime} onChange={setEndTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Inicio turno tolerancia</label>
                    <TimePicker value={toleranceTime} onChange={setToleranceTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Adicional</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Adicional" value={additional} options={additionalList} onChange={(e) => setAdditional(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Turno completo</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Turno completo" value={completeShift} options={completeList} onChange={(e) => setCompleteShift(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Día turno</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Día turno" value={shiftDay} options={daysList} onChange={(e) => setShiftDay(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Estado</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Estado" value={shiftStatus} options={statusList} onChange={(e) => setShiftStatus(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">¿Paga horas extras?</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="¿Paga horas extras?" value={overtime} options={extraList} onChange={(e) => setOvertime(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">¿Es descanso?</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="¿Es descanso?" value={rest} options={restList} onChange={(e) => setRest(e.value)} />
                </div>
            </Dialog>
            <Dialog header={updateShiftHeader} footer={updateShiftFooter} visible={isOpenShiftUpdate}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalShiftUpdate}>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">ID turno</label>
                    <InputText value={shiftId} placeholder="ID turno" className="p-inputtext-sm" disabled={true}/>
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">Nombre</label>
                    <InputText value={shiftName} onChange={(e) => setShiftName(e.target.value)} placeholder="Nombre" className="p-inputtext-sm"/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Inicio turno</label>
                    <TimePicker value={startTime} onChange={setStartTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Fin turno</label>
                    <TimePicker value={endTime} onChange={setEndTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Inicio turno tolerancia</label>
                    <TimePicker value={toleranceTime} onChange={setToleranceTime}/>
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Adicional</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Adicional" value={additional} options={additionalList} onChange={(e) => setAdditional(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Turno completo</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Turno completo" value={completeShift} options={completeList} onChange={(e) => setCompleteShift(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Día turno</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Día turno" value={shiftDay} options={daysList} onChange={(e) => setShiftDay(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">Estado</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="Estado" value={shiftStatus} options={statusList} onChange={(e) => setShiftStatus(e.value)} />
                </div>
                <div className='flex flex-column gap-1 mb-2'>
                    <label htmlFor="label">¿Paga horas extras?</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="¿Paga horas extras?" value={overtime} options={extraList} onChange={(e) => setOvertime(e.value)} />
                </div>
                <div className='flex flex-column gap-1'>
                    <label htmlFor="label">¿Es descanso?</label>
                    <Dropdown filter showClear filterBy="description" optionLabel='description' placeholder="¿Es descanso?" value={rest} options={restList} onChange={(e) => setRest(e.value)} />
                </div>
            </Dialog>
            <Dialog header={deleteShiftHeader} footer={deleteShiftFooter} visible={isOpenShiftDelete}
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalShiftDelete}>
            </Dialog>
            <div className="flex flex-column align-items-center justify-content-center font-bold text-4xl mt-5">
                <span className="text-900">Configuración Turnos</span>
            </div>
            {localStorage.getItem('tracking') === 'N'?
                <div className='flex justify-content-center'>
                    <Card style={{ width: "60%" }}>
                        <Message severity="info"
                        style={{
                            width: "100%",
                            fontSize: "18px",
                            border: 'solid #696cff',
                            borderWidth: '2px',
                            color: '#696cff'
                        }}
                        content={msgContent}
                        />
                    </Card>
                </div>:
                <SkeletonTable load={loadPage} width='90%'>
                    <DataTable className="card text-xs w-9 mt-6" value={shifts} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                        selection={shiftSelected} onSelectionChange={(e) => setShiftSelected(e.value)} dataKey="CONFIG_SHIFTS_ID" selectionMode={"single"}
                        size="small" filters={filters1} filterDisplay="menu" header={header1} 
                        globalFilterFields={['CONFIG_SHIFTS_ID', 'NAME', 'START_TIME', 'END_TIME', 'START_TIME_TOLERANCE', 'ADDITIONAL_DESC', 'COMPLETE_SHIFT_DESC', 
                        'LOV_SHIFT_DAY_DESC', 'LOV_STATUS_DESC', 'PAY_HE_DESC', 'REST_DAY_DESC']}
                    >
                        <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                        <Column field="CONFIG_SHIFTS_ID" header="ID" filter filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="NAME" header="Nombre" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
                        <Column field="START_TIME" header="Inicio turno" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Inicio turno" sortable></Column>
                        <Column field="END_TIME" header="Fin turno" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fin turno" sortable></Column>
                        <Column field="START_TIME_TOLERANCE" header="Inicio turno tolerancia" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Inicio turno tolerancia" sortable></Column>
                        <Column field="ADDITIONAL_DESC" header="Adicional" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Adicional" sortable></Column>
                        <Column field="COMPLETE_SHIFT_DESC" header="Turno completo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Turno completo" sortable></Column>
                        <Column field="LOV_SHIFT_DAY_DESC" header="Día turno" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Día turno" sortable></Column>
                        <Column field="LOV_STATUS_DESC" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                        <Column field="PAY_HE_DESC" header="¿Paga horas extras?" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ¿Paga horas extras?" sortable></Column>
                        <Column field="REST_DAY_DESC" header="¿Es descanso?" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ¿Es descanso?" sortable></Column>
                        <Column header="Acciones" headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
                    </DataTable>
                </SkeletonTable>}
        </div>
    )
}

export default ShiftConfiguration
